import React from "react";
import { Route, Routes } from "react-router-dom";

// LAYOUT / PAGES
import Layout from "../pages/home/Layout";
import NotFoundPage from "../pages/unauthorized/NotFoundPage";

// PRIVATE ROUTE
import PrivateRoute from "./PrivateRoute";

export default function PrivateRouter() {
  return (
    <Routes>
      <Route path="/" element={<PrivateRoute Component={Layout} />} />
      <Route path="/monitoring/*" element={<PrivateRoute Component={Layout} />} />
      <Route path="/dashboard/*" element={<PrivateRoute Component={Layout} />} />
      <Route path="/map-view/*" element={<PrivateRoute Component={Layout} />} />
      <Route path="/organization-management/*" element={<PrivateRoute Component={Layout} />} />
      <Route path="/users-management/*" element={<PrivateRoute Component={Layout} />} />
      <Route path="/notification-management/*" element={<PrivateRoute Component={Layout} />} />
      <Route path="/reports/*" element={<PrivateRoute Component={Layout} />} />
      <Route path="/tools/*" element={<PrivateRoute Component={Layout} />} />
      <Route path="/edge-management/*" element={<PrivateRoute Component={Layout} />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
